<template>
  <section id="services">
    <div class="services-container">
      <div
        v-for="(service, index) in services"
        :key="service.id"
        ref="cards"
        class="card"
        :style="{ animationDelay: `${index * 0.2}s` }"
      >
        <img :src="service.image" alt="Service Image" />
        <h3 class="card-title">{{ service.title }}</h3>
        <p>{{ service.description }}</p>
        <router-link  to="/services" class="btn-primary reserve-button">
          {{ service.buttonText }}
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
import { gsap } from "gsap";

export default {
  name: "ServicesSection",
  data() {
    return {
      services: [
        {
          id: 1,
          title: "Fiat 500 Rental",
          description: "Explore the city in our  historical Fiat.",
          buttonText: "Book Now",
          image: require("@/assets/images/Poorent-Fiat 500.jpg"),
        },
        {
          id: 2,
          title: "Golf Car Rental",
          description: "Experience luxury for special occasions.",
          buttonText: "Book Now",
          image: require("@/assets/images/poorent-GolfCar.jpg"),
        },
        {
          id: 3,
          title: "Segway Rental",
          description: "Drive green with our eco-friendly options.",
          buttonText: "Book Now",
          image: require("@/assets/images/poorent-Segwai.jpg"),
        },
      ],
    };
  },
  mounted() {
  // Animate the cards with a falling and rotating effect
  gsap.fromTo(
    this.$refs.cards, // Target each card
    {
      opacity: 0,      // Start invisible
      y: -300,         // Start from above the screen
      rotation: -360,   // Start with a rotated angle
    },
    {
      duration: 2,   // Duration of the animation
      opacity: 1,      // Fade in
      y: 0,            // End at their final position
      rotation: 0,     // End with no rotation
      stagger: 0.7,    // Delay each card's animation
      ease: "back.out(2)", // Add a bounce effect when settling
    }
  );
},
};
</script>

<style scoped>
.services-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
  align-items: stretch; /* Ensure all cards align to the same height */
}

.card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: white;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  padding: 20px;
  max-width: 300px;
  min-height: 350px; /* Set a consistent minimum height */
  text-align: center;
  transform-origin: center;
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.card img {
  width: 100%;
  border-radius: 10px;
  margin-bottom: 15px;
}

.card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
}

.card-title {
  color: var(--primary-color);
  font-size: 1.2rem;
  font-weight: bold;
}

.reserve-button {
  margin-top: 10px;
  background-color: #ff6f3c;
  color: white;
  border: none;
  padding: 0.5em 1em;
  border-radius: 0.5em;
  font-weight: bold;
  cursor: pointer;
  text-transform: uppercase;
  transition: background-color 0.3s ease, transform 0.2s ease;
  text-decoration: none;
}

.reserve-button:hover {
  background-color:  #6B8E23;
  transform: scale(1.05);
}
</style>
